import { createBrowserClient } from '@supabase/ssr';

const supabase_url = import.meta.env.VITE_SUPABASE_URL;
const supabase_anon_key = import.meta.env.VITE_SUPABASE_ANON_KEY;

/** When set (e.g. `.nouspigeons.ca`), session cookies are shared between app and website. Omit for local dev. */
const auth_cookie_domain = import.meta.env.VITE_AUTH_COOKIE_DOMAIN as string | undefined;

export const supabase = createBrowserClient(supabase_url, supabase_anon_key, {
  cookieOptions: {
    ...(auth_cookie_domain ? { domain: auth_cookie_domain } : {}),
    path: '/',
    sameSite: 'lax',
    secure: import.meta.env.PROD,
  },
});
